import React from "react";
import { Alert, Typography, Divider, Box, Chip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import ReplayIcon from "@mui/icons-material/Replay";
import HistoryIcon from "@mui/icons-material/History";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

export default function InfoBox() {
  return (
    <Alert severity="info" variant="outlined" sx={{ mb: 4 }}>
      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        Manage water meters:
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Create, edit, or delete meters. Install, remove, or transfer meters
        between wells. Track meter inventory and installation history.
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        Quick actions:
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Use the action buttons in each row to manage meters. Available meters
        can be installed, active meters can be transferred or removed.
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          gap: 1,
          mt: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EditIcon fontSize="small" color="action" />
          <Typography variant="body2">Edit details</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InstallDesktopIcon fontSize="small" color="success" />
          <Typography variant="body2">Install on well</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SwapHorizIcon fontSize="small" color="info" />
          <Typography variant="body2">Transfer meter</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <RemoveCircleIcon fontSize="small" color="warning" />
          <Typography variant="body2">Remove from well</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <HistoryIcon fontSize="small" color="action" />
          <Typography variant="body2">View history</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <BlockIcon fontSize="small" color="error" />
          <Typography variant="body2">Retire meter</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ReplayIcon fontSize="small" color="success" />
          <Typography variant="body2">Reactivate meter</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        Status indicators:
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          gap: 1,
          mt: 0.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip
            label="Available"
            color="info"
            variant="outlined"
            size="small"
          />
          <Typography variant="body2">Ready for installation</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip label="Active on Well" color="success" size="small" />
          <Typography variant="body2">Currently installed</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip label="Retired" color="error" variant="outlined" size="small" />
          <Typography variant="body2">No longer available</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ fontStyle: "italic" }}>
        Note: Meters with installation history cannot be deleted. Consider
        removing them from wells instead. Each meter can only be installed on
        one well at a time.
      </Typography>
    </Alert>
  );
}
